import React, { useContext, useEffect, useState } from 'react';
import { Row ,Button} from 'react-bootstrap';
import SimpleContext from '../context/SimpleContext';
import config from '../../services/config.json';
import axios from "axios";
import Preloader from '../common/Preloader';
import right from "../img/right.png";
import { useHistory } from 'react-router';


const SearchSortOrder = () => {

    const [sort,setSort]=useState(false)
    const history = useHistory()
    
    const context = useContext(SimpleContext);
    //فراخانی وب سرویس sortOrderList

    
    const [isLoading, setIsLoading] = useState(true);
    const onChangeValueRadio = (e) => {
        context.setsearchBodyOfProduct({})
        let sortOrderValue = 0;
        sortOrderValue = (parseInt(e.target.value))
        context.setsort(sortOrderValue)
        context.search(0, context.SearchField, 0, context.showCatId,context.SelectedBrandsList,context.sort,context.searchBodyOfProduct);
        context.categories(context.showCatId,context.SelectedBrandsList)
    }
    // const HandlecleareAllAndReload = () => {
    //     context.setTreeMenuSelectedId(0)
    //     context.setFilterPriceRange([0,0])
    //     context.setSelectedBrandsList([])
    //     context.handleShowSearchProducts(0, setIsLoading)
    // }
    return (  
        <>
        {
        sort===true?
        <Preloader/>
        :
        <div style={{width:"100%",display:'flex',justifyContent:'flex-start',flexDirection:'column'}} className="SortOrderMain">
            <div className="Header">
            <div className="HeaderColsCenter" style={{width:"45%",justifyContent:'flex-start',}}>
              <img style={{width:'13px',margin:'10px'}} onClick={()=>history.go(-2)} src={right}/>
            </div>
            <div className="HeaderColsCenter" style={{width:"70%",justifyContent:'flex-start'}}>
                <h1 style={{margin:"0",fontSize:"14px",fontWeight:'bold',color:'#000',margin:'0'}}>ترتیب نمایش</h1>
            </div>
            </div>
            <div className='sortList'>
            {
                context.List.length > 0?
                context.List.map((i,j)=>
                    <div className="SortOrderMainRows" key={j} onChange={(e)=>onChangeValueRadio(e)}>
                      {/* <input  type="radio" id="html" name="fav_language" value="HTML"/>
                      <label  for="html">{i.title}</label>   */}
                      <input style={{fontWeight:'bold'}} type="checkbox" name="sortOrder" value={i.id} class="larger" checked={i.id ===context.sort}/> {' '}{i.title}{' '}
                    </div>
                    )
                    :null
            }
            </div>
           
        </div>
        }
        </>
    );
}
 
export default SearchSortOrder;